import React from "react";

export default function Contact({ t }) {
  const handleSubmit = (e) => {
    e.preventDefault();

    const name = e.target.elements.name.value.trim();
    const email = e.target.elements.email.value.trim();
    const message = e.target.elements.message.value.trim();

    if (!name || !email || !message) {
      alert("⚠️ Please fill in all fields");
      return;
    }
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      alert("⚠️ Please enter a valid email address");
      return;
    }

    // default mail client
    const mailtoLink = `mailto:info@aarvek.com?subject=Message from ${encodeURIComponent(
      name
    )}&body=Name: ${encodeURIComponent(name)}%0D%0AEmail: ${encodeURIComponent(
      email
    )}%0D%0A%0D%0AMessage:%0D%0A${encodeURIComponent(message)}`;

    window.location.href = mailtoLink;

    // fallback: open Gmail in browser
    setTimeout(() => {
      const gmailLink = `https://mail.google.com/mail/?view=cm&fs=1&to=info@aarvek.com&su=Message from ${encodeURIComponent(
        name
      )}&body=Name: ${encodeURIComponent(name)}%0D%0AEmail: ${encodeURIComponent(
        email
      )}%0D%0A%0D%0AMessage:%0D%0A${encodeURIComponent(message)}`;
      window.open(gmailLink, "_blank");
    }, 500);
  };

  return (
    <section id="contact" className="contact">
      <h3>{t.contact.title}</h3>
      <form onSubmit={handleSubmit}>
        <input type="text" name="name" placeholder={t.contact.name} required />
        <input type="email" name="email" placeholder={t.contact.email} required />
        <textarea name="message" placeholder={t.contact.msg} rows="4" required></textarea>
        <button type="submit">{t.contact.send}</button>
      </form>
    </section>
  );
}
